import { List, Map, Record } from 'immutable'
import {
  PhoenixStatus,
} from './constants'

export function parsePresenceUsers(data) {
  return Map(data).map(parsePresenceUser)
}

export function parsePresenceUser(data) {
  const { meta, metasByRef, ...rest } = data
  return PresenceUser({
    meta: !!meta && parseMeta(meta),
    metasByRef: Map(metasByRef).map(parseMeta),
    ...rest
  })
}

export function parseMeta(data) {
  const { page, geo, reveal,  ...rest } = data
  return PresenceMeta({
    page: PresenceMetaPage(page),
    geo: PresenceMetaGeo(geo),
    companyInfo: {...reveal},
    ...rest,
  })
}

export function parsePresenceVisitor(data) {
  const { endUser, ...rest } = data
  return PresenceVisitor({
    endUserId: endUser && endUser.id || rest.id,
    ...rest
  })
}

export const PresenceState = Record({
  bufferedUsers: Map(),
  newLiveUsers: List(),
  newLiveUsersCount: 0,
  toggle: false,
  filters: List(),
  newFilters: Map(),
  newSorts: Map(),
  showMore: false,
  filterKnownUsers: false,
  pagination: { currentIndex: 0, userLoadCount: 50 },
  interval: 5000,
  activeStatus: { isActive: true },
  presenceProblems: false,
  presenceLoading: false,
  hasProcessedUsers: false,
  usersWithMessageSent: [],
})


export const PresenceSession = Record({
  numSessions: undefined,
  numPageViews: undefined,
  activeSessionStartedAt: undefined,
  currentSessionStartedAt: undefined,
  currentPageViewStartedAt: undefined,
  previousSessionStartedAt: undefined,
  previousSessionEndedAt: undefined,
  firstSessionAt: undefined
})


export const PresenceBrowser = Record({
  userAgent: undefined,
  timezone: undefined,
  locale: undefined,
})

export const PresenceMetaPage = Record({
  search: undefined,
  hostname: undefined,
  path: undefined,
  url: undefined,
  href: undefined,
  title: undefined,
  referrer: undefined,
})

export const PresenceMetaGeo = Record({
  city: undefined,
  subdivision: undefined,
  country: undefined,
  countryName: undefined,
  latitude: undefined,
  longitude: undefined,
  latLong: undefined,
  metroCode: undefined,
  postalCode: undefined,
  ip: undefined,
  gdprApplicable: undefined
})

export const PresenceCompany = Record({
  name: undefined
})

export const PresenceVisitor = Record({
  id: undefined,
  orgId: undefined,
  updatedAt: undefined,
  endUserId: undefined,
  browser: new PresenceBrowser(),
  session: new PresenceSession(),
  page: new PresenceMetaPage(),
  location: new PresenceMetaGeo(),
  company: new PresenceCompany()
})

export const PresenceMeta = Record({
  phx_ref: undefined,
  phx_ref_prev: undefined,
  phx_status: PhoenixStatus.CONNECTED,
  ip: undefined,
  email: undefined,
  page: new PresenceMetaPage(),
  onlineAt: undefined,
  lastUpdateAt: undefined,
  externalId: undefined,
  anonymousId: undefined,
  userType: '',
  userId: undefined,
  geo: new PresenceMetaGeo(),
  companyInfo: undefined
})

export const PresenceUser = Record({
  id: undefined,
  meta: new PresenceMeta(),
  metaJson: '',
  metasByRef: Map(),
  className: ''
})



// WEBPACK FOOTER //
// ./src/scripts/app/modules/presence/models.js